import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
 
} from "react-icons/di";

import {
  SiMicrosoftsharepoint,
  SiPowerapps,
  SiPowerautomate,
  SiPowerbi,
  SiMicrosoftazure,
  SiMicrosoftoffice,
  SiMicrosoftexcel,
} from "react-icons/si";


function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
      </Col>
      
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>
      
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb />
      </Col>

            <Col xs={4} md={2} className="tech-icons">
        <SiMicrosoftsharepoint />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiPowerapps />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiPowerautomate />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiPowerbi />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiMicrosoftazure />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiMicrosoftoffice />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiMicrosoftexcel />
      </Col>
    </Row>
  );
}

export default Techstack;
